import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHomeQuery } from 'queries';
import { saveHomeResponseSagaAction } from '../actions';
import { selectHomeItems } from '../selectors';

export const useHomeStore = () => {
  const dispatch = useDispatch();

  const { data: queryResult, ...rest } = useHomeQuery({
    onSuccess: (result) => {
      dispatch(saveHomeResponseSagaAction(result));
    },
  });

  const data = useSelector(selectHomeItems, shallowEqual);

  return {
    data: {
      ...data,
      approvals: queryResult?.approvals || [],
    },
    ...rest,
  };
};
